import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import EventsFilters from '@web/components/Settings/Events/EventsFilters';
import EventsTable from '@web/components/Settings/Events/EventsTable/EventsTable';
var Events = function () {
    return (_jsxs(_Fragment, { children: [_jsx(EventsFilters, {}), _jsx(EventsTable, {})] }));
};
export default Events;
